export const TitleGenerator = title => {
  let newTitle = title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\-_~]+/g, '-');

  if (newTitle.at(0) === '-') newTitle = newTitle.slice(1);
  if (newTitle.at(-1) === '-') newTitle = newTitle.slice(0, -1);

  return newTitle;
};
